import { render, staticRenderFns } from "./DepartmentList.vue?vue&type=template&id=5802d7b6&"
import script from "./DepartmentList.vue?vue&type=script&lang=ts&"
export * from "./DepartmentList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports